import { render, staticRenderFns } from "./SocialIcon.vue?vue&type=template&id=474d1e7e&functional=true"
import script from "./SocialIcon.vue?vue&type=script&lang=js"
export * from "./SocialIcon.vue?vue&type=script&lang=js"
import style0 from "./SocialIcon.vue?vue&type=style&index=0&id=474d1e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports